import { type SupportedLocaleMap } from '@zep-us/i18n';
import { Trans, useTranslation } from 'next-i18next';
import { CMS_CDN } from '@/consts/env';
import { useLocale } from '@/hooks';
import { FunctionCard, FunctionCards } from '@/shared/components';
export const Teacher = () => {
  const {
    t
  } = useTranslation(['landing', 'common']);
  return <section className="px-[16px] py-2xl min-[751px]:px-[24px] min-[1025px]:px-[40px] min-[1025px]:py-3xl" data-sentry-component="Teacher" data-sentry-source-file="Teacher.tsx">
      <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center gap-lg min-[751px]:items-stretch min-[751px]:gap-2xl">
        <h2 className="px-[16px] text-center text-display-sm-extrabold text-default min-[751px]:whitespace-normal min-[751px]:text-left">
          {t('landing.teacherFeatures.title')}
        </h2>
        <FunctionCards topElement={<Function1 />} bottomLeftElement={<Function2 />} bottomRightElement={<Function3 />} data-sentry-element="FunctionCards" data-sentry-source-file="Teacher.tsx" />
      </div>
    </section>;
};
const FUNCTION_1_IMAGE_LINKS: SupportedLocaleMap<'ko' | 'en' | 'ja'> = {
  ko: `${CMS_CDN}/medias/9z7bCJzn/nUz/w1rqQ3wK87durTwZw7XwnUz/en-US/1/quiz_landing_1_1_image_kr_2x.webp`,
  en: `${CMS_CDN}/medias/9z7bCJzn/Yao/DuNOw3wK87durTwZw43qYao/en-US/1/quiz_landing_1_1_image_en_2x.webp`,
  ja: `${CMS_CDN}/medias/9z7bCJzn/SRk/pC4zP3wK87curTwZw5pnSRk/en-US/1/quiz_landing_1_1_image_jp_2x.webp`
};
const Function1 = () => {
  const {
    t
  } = useTranslation(['landing', 'common']);
  const {
    locale
  } = useLocale();
  return <FunctionCard.HorizontalWrapper className="bg-purple-50" data-sentry-element="unknown" data-sentry-component="Function1" data-sentry-source-file="Teacher.tsx">
      <div className="flex-1">
        <div className="flex size-full flex-col items-center gap-sm px-lg py-xl min-[751px]:items-stretch min-[751px]:gap-lg min-[751px]:p-2xl min-[751px]:pr-0 min-[1025px]:p-3xl min-[1025px]:pr-0">
          <FunctionCard.Title className="text-purple-800" data-sentry-element="unknown" data-sentry-source-file="Teacher.tsx">
            <Trans t={t} i18nKey="landing.teacherFeature1.title1_new" components={{
            Br: <br className="hidden min-[751px]:block min-[1024px]:hidden" />
          }} data-sentry-element="Trans" data-sentry-source-file="Teacher.tsx" />
          </FunctionCard.Title>
          <FunctionCard.Description data-sentry-element="unknown" data-sentry-source-file="Teacher.tsx">
            {t('landing.teacherFeature1.content')}
          </FunctionCard.Description>
        </div>
      </div>

      <div className="flex-1 min-[751px]:h-[310px] min-[1025px]:h-[374px]">
        <img src={FUNCTION_1_IMAGE_LINKS[locale] ?? FUNCTION_1_IMAGE_LINKS.en} alt="Function 1" className="size-full min-[751px]:object-cover min-[751px]:object-left" />
      </div>
    </FunctionCard.HorizontalWrapper>;
};
const FUNCTION_2_IMAGE_LINKS: SupportedLocaleMap<'ko' | 'en' | 'ja'> = {
  ko: `${CMS_CDN}/medias/9z7bCJzn/1kI/ADOzJ3wK87durTwZw5Yw1kI/en-US/1/quiz_landing_1_2_image_kr_2x.webp`,
  en: `${CMS_CDN}/medias/9z7bCJzn/Pc5/QTJ7Q3wK87curTwZw7sGPc5/en-US/1/quiz_landing_1_2_image_en_2x.webp`,
  ja: `${CMS_CDN}/medias/9z7bCJzn/Kjo/C2b6T3wK87curTwZw7A0Kjo/en-US/1/quiz_landing_1_2_image_jp_2x.webp`
};
const Function2 = () => {
  const {
    t
  } = useTranslation(['landing', 'common']);
  const {
    locale
  } = useLocale();
  return <FunctionCard.VerticalWrapper className="bg-purple-100" data-sentry-element="unknown" data-sentry-component="Function2" data-sentry-source-file="Teacher.tsx">
      <div className="flex flex-col items-center gap-sm px-lg py-xl min-[751px]:items-stretch min-[751px]:gap-lg min-[751px]:p-2xl min-[751px]:pb-0 min-[1025px]:p-3xl min-[1025px]:pb-0">
        <FunctionCard.Title className="text-purple-900" data-sentry-element="unknown" data-sentry-source-file="Teacher.tsx">
          {t('landing.teacherFeature2.title')}
        </FunctionCard.Title>
        <FunctionCard.Description data-sentry-element="unknown" data-sentry-source-file="Teacher.tsx">
          {t('landing.teacherFeature2.content')}
        </FunctionCard.Description>
      </div>

      <img src={FUNCTION_2_IMAGE_LINKS[locale] ?? FUNCTION_2_IMAGE_LINKS.en} alt="Function 2" />
    </FunctionCard.VerticalWrapper>;
};
const Function3 = () => {
  const {
    t
  } = useTranslation(['landing', 'common']);
  return <FunctionCard.VerticalWrapper className="bg-[#F6F3FA]" data-sentry-element="unknown" data-sentry-component="Function3" data-sentry-source-file="Teacher.tsx">
      <div className="flex flex-col items-center gap-sm px-lg py-xl min-[751px]:items-stretch min-[751px]:gap-lg min-[751px]:p-2xl min-[751px]:pb-0 min-[1025px]:p-3xl min-[1025px]:pb-0">
        <FunctionCard.Title className="text-purple-900" data-sentry-element="unknown" data-sentry-source-file="Teacher.tsx">
          {t('landing.teacherFeature3.title')}
        </FunctionCard.Title>
        <FunctionCard.Description data-sentry-element="unknown" data-sentry-source-file="Teacher.tsx">
          {t('landing.teacherFeature3.content')}
        </FunctionCard.Description>
      </div>

      <img src={`${CMS_CDN}/medias/9z7bCJzn/4Ya/XHccZ3wK87curTxdqoZM4Ya/en-US/1/quiz_landing_1_3_image_kr_2x.webp`} alt="Function 3" />
    </FunctionCard.VerticalWrapper>;
};